import noodleApiClient, { type ApiDefinition } from '@/tsClient/servers/noodleApi';

type ThisApi = ApiDefinition['/form-requests/{formRequestId}/case-document-pdf']['POST'];

type Input = ThisApi['params'];
type Output = ThisApi['response'];

const generateCaseDocumentPdf = async ({ formRequestId }: Input): Promise<Output> => {
  const data = await noodleApiClient.post(`/form-requests/${formRequestId}/case-document-pdf`);
  return data.data;
};

export default generateCaseDocumentPdf;
